<template>
  <div class="vant-table">
    <table cellspacing="0" style="width:100%" class="table">
      <tr v-for="(item, index) in tableData" :key="index" class="list-tr">
        <td v-for="(context, i) in option.column" :key="i" :style="context.width">{{ item[context.prop] }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props:{
    tableData: Array,
    option: Object
  },
  created() {}
};
</script>

<style lang="less" scoped>
.vant-table {
  table {
    color: #393939;
    border-spacing:0px;
    border:1px solid #C6C6C6;
    border-radius:10px;
    tr>th {
      font-size: 1rem;
      font-weight: normal;
      border-right:1px solid #C6C6C6;
      border-bottom:1px solid #C6C6C6;
      padding: 1rem;
    }
    tr>th:last-child {
      border-right:none;
    }
    tr:last-child {
      th {
        border-bottom:none;
      }
    }
    tr>td {
      font-size: .9rem;
      border-right:1px solid #C6C6C6;
      border-bottom:1px solid #C6C6C6;
      padding: 14px;
    }
    tr>td:last-child {
      border-right:none;
    }
    tr:last-child {
      td {
        border-bottom:none;
      }
    }
  }
}
</style>
